import React from 'react';
import HomeListManager from '../admincomponents/HomeListManager';

function AdminHomeBadges() {
  return (
    <HomeListManager
      title="Badges Strip"
      urlPath="home-badges"
      emptyMessage='No badges yet — click "Add" to create the first one (shown just below the hero banner).'
      fields={[
        { name: 'title', label: 'Title', required: true, colClass: 'col-md-8', placeholder: 'e.g. CPD UK Accredited Academy' },
        { name: 'link_url', label: 'Link (optional)', colClass: 'col-md-4', placeholder: '/about' },
      ]}
    />
  );
}

export default AdminHomeBadges;
